import { getCurrentInstance } from 'vue';

export function useCoreAccessor () {
    const vm = getCurrentInstance();
    if (!vm) {
        throw new Error('Not in a Vue instance!');
    }
    return vm.proxy.$accessor;
}
